import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/taxHisotry',
    name: 'TaxHisotry',
    component: () => import(/* webpackChunkName: "TaxHisotry" */ '../page/tax/TaxHisotry.vue')
  },
  {
    path: '/',
    name: 'indexPage',
    component: () => import(/* webpackChunkName: "indexPage" */ '../page/indexPage.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
